module.exports = __webpack_public_path__ + "media/styles/images/svg/project-teal-49d37a2b83fb354eaa227bc72ecf1d68.svg";